// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  DatePicker,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  Tag,
  Upload
} from '@arco-design/web-react';
import { post, get, put, del as deleteRequest } from '../requestNew';
import dayjs from 'dayjs';

import './index.scss';
import { baseUrl } from '../utils';
import PhoneCell from '../components/PhoneCell';
import type { UmsUser } from './types';

const FormItem = Form.Item;
const Option = Select.Option;
const { MonthPicker } = DatePicker;

const educationOptions = [
  { label: '全部', value: '' },
  { label: '初高中', value: 1 },
  { label: '普通本科', value: 2 },
  { label: '本科(985-211)', value: 3 },
  { label: '硕士研究生', value: 4 },
  { label: '博士研究生', value: 5 }
];

const educationMap: Record<number, string> = {
  1: '初高中',
  2: '普通本科',
  3: '本科(985-211)',
  4: '硕士研究生',
  5: '博士研究生'
};

const educationTagColors: Record<number, { bg: string; text: string }> = {
  1: { bg: '#F2F3F5', text: '#4E5969' },
  2: { bg: '#E8F3FF', text: '#165DFF' },
  3: { bg: '#E8FFFB', text: '#0FC6C2' },
  4: { bg: '#FFF7E8', text: '#FF7D00' },
  5: { bg: '#F5E8FF', text: '#722ED1' }
};

const tradingStyleTagColors: Record<string, { bg: string; text: string }> = {
  cycle: { bg: '#E8F3FF', text: '#165DFF' },
  position: { bg: '#E8FFFB', text: '#0FC6C2' },
  method: { bg: '#FFF7E8', text: '#FF7D00' },
  variety: { bg: '#F5E8FF', text: '#722ED1' }
};

const getTradingStyleTagColor = (code: string) => {
  const prefix = code?.split('_')[0];
  return tradingStyleTagColors[prefix] || { bg: '#F2F3F5', text: '#4E5969' };
};

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function UserManagement() {
  const [form] = Form.useForm<UmsUser>();
  const [formSearch] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<UmsUser[]>([]);
  const [loading, setLoading] = useState(false);
  const [orderBy, setOrderBy] = useState<string>('');
  const formRef = useRef<any>({});
  const prevSorterRef = useRef<any>(null);
  const [tradingStyleLabelMap, setTradingStyleLabelMap] = useState<Record<string, string>>({});
  const [tradingStyleOptions, setTradingStyleOptions] = useState<{ label: string; value: string }[]>([]);
  // const URL_UPLOAD = baseUrl + '/sysMenu/uploadImage';
  const URL_UPLOAD = baseUrl + '/common/uploadFile';

  // 是否拉黑 / 是否高手选项
  const booleanOptions = [
    { label: '全部', value: '' },
    { label: '是', value: true },
    { label: '否', value: false }
  ];
  const blackOptions = booleanOptions;
  const masterOptions = booleanOptions;

  // 用户判罚选项映射
  const penaltyMap: Record<number, { label: string; color: string }> = {
    0: { label: '正常', color: 'green' },
    1: { label: '黄牌', color: 'orange' },
    2: { label: '红牌', color: 'red' }
  };

  // 处理拉黑开关变更
  const handleBlackChange = (val: boolean, record: UmsUser) => {
    if (!record.id) {
      Message.error('用户ID不存在！');
      return;
    }

    if (val) {
      let reason = record.blackReason || '';
      Modal.confirm({
        title: '拉黑用户',
        content: (
          <div>
            <div style={{ marginBottom: 8 }}>请填写拉黑原因：</div>
            <Input.TextArea
              placeholder="请输入拉黑原因"
              defaultValue={reason}
              maxLength={500}
              showWordLimit
              autoSize={{ minRows: 3, maxRows: 6 }}
              onChange={v => {
                reason = v;
              }}
            />
          </div>
        ),
        onOk: () => {
          if (!reason || !reason.trim()) {
            Message.error('请输入拉黑原因');
            return Promise.reject();
          }
          return submitBlackUpdate(record, true, reason.trim());
        }
      });
      return;
    }

    Modal.confirm({
      title: '提示',
      content: '是否确认取消拉黑该用户？',
      onOk: () => submitBlackUpdate(record, false, '')
    });
  };

  const submitBlackUpdate = (record: UmsUser, black: boolean, blackReason: string) => {
    setLoading(true);
    const updateData = {
      ...record,
      black: black ? 1 : 0,
      blackReason: black ? blackReason : ''
    };

    return put(`/backend/umsUser/${record.id}`, updateData)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 处理核心圈子高手开关变更
  const handleWhiteChange = (val: boolean, record: UmsUser) => {
    if (!record.id) {
      Message.error('用户ID不存在！');
      return;
    }
    setLoading(true);
    const updateData = {
      ...record,
      isWhite: val ? 1 : 0
    };

    put(`/backend/umsUser/${record.id}`, updateData)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 处理逻辑删除开关变更
  const handleIsValidChange = (val: boolean, record: UmsUser) => {
    if (!record.id) {
      Message.error('用户ID不存在！');
      return;
    }
    setLoading(true);
    const updateData = {
      ...record,
      isValid: val ? 1 : 0
    };

    put(`/backend/umsUser/${record.id}`, updateData)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 重置筛选条件
  const handleReset = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(20);
    setOrderBy('');
    getList(true);
  };

  // 表格列配置
    const columns: TableColumnProps[] = [
    {
      title: '序号',
      width: 60,
      render: (_, record, i) => (pageNum - 1) * pageSize + i + 1
    },
    {
      title: 'openid',
      dataIndex: 'openId',
      width: 150
    },
    {
      title: 'oneId',
      dataIndex: 'oneId',
      width: 150,
      render: text => text || '-'
    },
    {
      title: '用户名',
      dataIndex: 'gameName',
      width: 120
    },
    {
      title: '用户头像',
      dataIndex: 'profilePic',
      width: 100,
      render: (text) => {
        if (text) {
          return (
            <img 
              src={text} 
              alt="头像" 
              style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                objectFit: 'cover' 
              }} 
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
          );
        }
        return '-';
      }
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      width: 160,
      render: text => <PhoneCell phone={text} />
    },
    {
      title: '入市年月',
      dataIndex: 'marketEntryTime',
      width: 110,
      render: text => (text ? dayjs(text).format('YYYY-MM') : '-')
    },
    {
      title: '学历',
      dataIndex: 'education',
      width: 130,
      render: text => {
        const label = educationMap[text as number];
        if (!label) {
          return '-';
        }
        const tagColor = educationTagColors[text as number] || { bg: '#F2F3F5', text: '#4E5969' };
        return (
          <Tag color={tagColor.bg} style={{ color: tagColor.text, border: 'none' }}>
            {label}
          </Tag>
        );
      }
    },
    {
      title: '交易风格',
      dataIndex: 'tradingStyles',
      width: 200,
      render: (text: string[]) => {
        if (!text || !text.length) {
          return '-';
        }
        return (
          <Space wrap size={[4, 4]}>
            {text.map(code => {
              const tagColor = getTradingStyleTagColor(code);
              return (
                <Tag
                  key={code}
                  color={tagColor.bg}
                  style={{ color: tagColor.text, border: 'none' }}
                >
                  {tradingStyleLabelMap[code] || code}
                </Tag>
              );
            })}
          </Space>
        );
      }
    },
    {
      title: '参赛次数',
      dataIndex: 'competitionCount',
      width: 100,
      render: text => text || 0,
      sorter: true
    },
    {
      title: '参加赛季',
      dataIndex: 'competitionHistory',
      width: 120,
      render: text => text || '-'
    },
    {
      title: '首次登录时间',
      dataIndex: 'firstLoginTime',
      width: 180,
      render: text => text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    {
      title: '是否拉黑',
      dataIndex: 'black',
      width: 100,
      render: (text, record) => (
        <Switch 
          checked={text === 1 || text === true} 
          onChange={val => handleBlackChange(val, record)} 
        />
      )
    },
    {
      title: '拉黑原因',
      dataIndex: 'blackReason',
      width: 200,
      ellipsis: true,
      render: text => text || '-'
    },
    {
      title: '是否专家',
      dataIndex: 'isExpert',
      width: 100,
      render: (text, record) => (
        <Switch 
          disabled
          checked={text === 1 || text === true} 
        />
      )
    },
    {
      title: '是否高手',
      dataIndex: 'isMaster',
      width: 100,
      render: (text, record) => (
        <Switch 
          disabled
          checked={text === 1 || text === true} 
        />
      )
    },
    {
      title: '核心圈子高手',
      dataIndex: 'isWhite',
      width: 120,
      render: (text, record) => (
        <Switch 
          checked={text === 1 || text === true} 
          onChange={val => handleWhiteChange(val, record)} 
        />
      )
    },
    {
      title: '是否会员',
      dataIndex: 'isMember',
      width: 100,
      render: (text, record) => (
        <Switch
          disabled
          checked={text === 1 || text === true}
        />
      )
    },
    {
      title: '是否复盘会员',
      dataIndex: 'isReviewMember',
      width: 120,
      render: (text, record) => (
        <Switch
          disabled
          checked={text === 1 || text === true}
        />
      )
    },
    {
      title: '会员过期时间',
      dataIndex: 'memberExpireTime',
      width: 160,
      render: (_text, record: UmsUser) => {
        const time = (record as any)?.memberExpireTime;
        return time ? dayjs(time).format('YYYY-MM-DD') : '-';
      }
    },
    {
      title: '复盘过期时间',
      dataIndex: 'reviewMemberExpireTime',
      width: 160,
      render: (_text, record: UmsUser) => {
        const time = record?.reviewMemberExpireTime;
        return time ? dayjs(time).format('YYYY-MM-DD') : '-';
      }
    },
    {
      title: '是否删除',
      dataIndex: 'isValid',
      width: 100,
      render: (text, record) => (
        <Switch 
          disabled
          checked={text === 0 || text === false || text === null || text === undefined} 
          onChange={val => handleIsValidChange(val, record)} 
        />
      )
    },
    {
      title: '用户判罚',
      dataIndex: 'penalty',
      width: 100,
      render: (text) => {
        const penaltyInfo = penaltyMap[text as number] || penaltyMap[0];
        return (
          <Tag color={penaltyInfo.color}>{penaltyInfo.label}</Tag>
        );
      }
    },
    {
      title: '备注',
      dataIndex: 'tag',
      width: 120,
      render: text => text || '-'
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 150,
      render: (_, record: UmsUser) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)} loading={loading}>
            编辑
          </Button>
          <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => del(record)}>
            <Button className="btn" type="text" status="danger" loading={loading}>
              删除
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  // 获取数据列表
  const getList = (reset?: boolean, customOrderBy?: string) => {
    setLoading(true);
    if (reset) {
      setPageNum(1);
      setPageSize(20);
    }

    const searchValues = formSearch.getFieldsValue();
    const params: any = {
      ...searchValues,
      pageNum: reset ? 1 : pageNum,
      pageSize: reset ? 20 : pageSize
    };

    // 处理是否拉黑参数
    if (params.black === '') {
      delete params.black;
    }
    if (params.isMaster === '') {
      delete params.isMaster;
    }
    if (params.isWhite === '') {
      delete params.isWhite;
    }
    if (params.isMember === '') {
      delete params.isMember;
    }
    if (params.isReviewMember === '') {
      delete params.isReviewMember;
    }
    // 处理 openId 参数，空字符串时不传递
    if (params.openId === '' || !params.openId) {
      delete params.openId;
    }
    if (params.oneId === '' || !params.oneId) {
      delete params.oneId;
    }
    if (params.education === '' || params.education === undefined) {
      delete params.education;
    }
    if (params.tradingStyle === '' || !params.tradingStyle) {
      delete params.tradingStyle;
    }
    if (params.marketEntryTime) {
      params.marketEntryTime = dayjs(params.marketEntryTime).startOf('month').format('YYYY-MM-DD');
    } else {
      delete params.marketEntryTime;
    }

    // 添加排序参数
    const finalOrderBy = customOrderBy !== undefined ? customOrderBy : orderBy;
    if (!!finalOrderBy) {
      params.orderByGameCount = finalOrderBy;
    }

    get('/backend/umsUser/list', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total: totalCount } = data || {};
          setTotal(totalCount || 0);
          setDataList(list || []);
        } else {
          Message.error(message || '获取数据失败!');
        }
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 新增用户
  const add = () => {
    formRef.current = {};
    form.resetFields();
    form.setFieldsValue({
      black: false,
      blackReason: '',
      profilePic: ''
    });
    setVisible(true);
  };

  // 删除用户
  const del = (record: UmsUser) => {
    if (!record.id) {
      Message.error('用户ID不存在！');
      return;
    }
    setLoading(true);

    deleteRequest(`/backend/umsUser/${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 编辑用户
  const edit = (record: UmsUser) => {
    formRef.current = record;
    form.setFieldsValue({
      ...record,
      black: record.black === 1 || record.black === true,
      blackReason: record.blackReason || ''
    });
    setVisible(true);
  };

  // 取消编辑
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };

  // 提交表单
  const onOk = () => {
    form.validate().then(values => {
      setLoading(true);
      const data = {
        ...formRef.current,
        ...values,
        black: values.black ? 1 : 0,
        blackReason: values.black ? (values.blackReason || '').trim() : ''
      };

      if (formRef.current.id) {
        // 更新用户：PUT /backend/umsUser/{id}
        put(`/backend/umsUser/${formRef.current.id}`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('编辑成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        // 创建用户：POST /backend/umsUser
        post(`/backend/umsUser/create`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('新增成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  useEffect(() => {
    get('/backend/umsUser/listTradingStyles')
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200 && Array.isArray(data)) {
          const labelMap: Record<string, string> = {};
          const options: { label: string; value: string }[] = [];
          data.forEach((category: any) => {
            (category.options || []).forEach((option: any) => {
              labelMap[option.code] = option.name;
              options.push({ label: option.name, value: option.code });
            });
          });
          setTradingStyleLabelMap(labelMap);
          setTradingStyleOptions(options);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);

  return (
    <div className="user-management table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="参赛名" field="gameName">
            <Input style={{ width: 190 }} placeholder="请输入..." allowClear />
          </FormItem>
          <FormItem label="手机号" field="phone">
            <Input style={{ width: 190 }} placeholder="请输入..." allowClear />
          </FormItem>
          <FormItem label="openid" field="openId">
            <Input style={{ width: 190 }} placeholder="请输入..." allowClear />
          </FormItem>
          <FormItem label="oneId" field="oneId">
            <Input style={{ width: 190 }} placeholder="请输入..." allowClear />
          </FormItem>
          <FormItem label="入市年份" field="marketEntryTime">
            <MonthPicker style={{ width: 150 }} allowClear placeholder="请选择" format="YYYY-MM" />
          </FormItem>
          <FormItem label="学历" field="education">
            <Select style={{ width: 150 }} allowClear placeholder="请选择">
              {educationOptions.map(option => (
                <Option key={String(option.value)} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="交易风格" field="tradingStyle">
            <Select style={{ width: 150 }} allowClear placeholder="请选择">
              {tradingStyleOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="是否高手" field="isMaster">
            <Select style={{ width: 150 }} allowClear placeholder="请选择">
              {masterOptions.map(option => (
                <Option key={String(option.value)} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="核心圈子高手" field="isWhite">
            <Select style={{ width: 150 }} allowClear placeholder="请选择">
              {masterOptions.map(option => (
                <Option key={String(option.value)} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="是否会员" field="isMember">
            <Select style={{ width: 150 }} allowClear placeholder="请选择">
              {masterOptions.map(option => (
                <Option key={String(option.value)} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="是否复盘会员" field="isReviewMember">
            <Select style={{ width: 150 }} allowClear placeholder="请选择">
              {masterOptions.map(option => (
                <Option key={String(option.value)} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="是否拉黑" field="black">
            <Select style={{ width: 150 }} allowClear placeholder="请选择">
              {blackOptions.map(option => (
                <Option key={String(option.value)} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={() => getList(true)} loading={loading}>
              查询
            </Button>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={handleReset} loading={loading}>
              重置
            </Button>
          </FormItem>
          <FormItem>
            <Button className="filter-item" type="primary" onClick={add} loading={loading}>
              新增
            </Button>
          </FormItem>
        </Form>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            sizeOptions: [20, 50, 100],
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
          loading={loading}
          onChange={(pagination, sorter) => {
            // 只有当 sorter 存在且有 direction 时，才认为是排序操作
            // 如果 sorter 不存在或没有 direction，且之前也没有，则忽略（分页操作）
            const hasSorterDirection = sorter && sorter.direction;
            const prevSorter = prevSorterRef.current;
            const prevHasDirection = prevSorter && prevSorter.direction;
            
            // 只有当排序状态真正变化时才处理
            // 情况1: 从无排序变为有排序
            // 情况2: 从有排序变为无排序
            // 情况3: 排序方向或字段发生变化
            const sorterChanged = 
              (hasSorterDirection && !prevHasDirection) || // 开始排序
              (!hasSorterDirection && prevHasDirection) || // 取消排序
              (hasSorterDirection && prevHasDirection && (
                prevSorter.field !== sorter.field || 
                prevSorter.direction !== sorter.direction
              )); // 排序变化
            
            // 只有当排序变化时才处理
            if (sorterChanged) {
              prevSorterRef.current = sorter ? { ...sorter } : null;
              // 处理排序变化
              if (sorter && sorter.field === 'competitionCount' && sorter.direction) {
                let newOrderBy = '';
                if (sorter.direction === 'ascend') {
                  newOrderBy = 'asc';
                } else if (sorter.direction === 'descend') {
                  newOrderBy = 'desc';
                }
                setOrderBy(newOrderBy);
                getList(true, newOrderBy);
              } else {
                // 取消排序
                setOrderBy('');
                getList(true, '');
              }
            }
          }}
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑用户' : '新增用户'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={loading}
      >
        <Form {...formItemLayout} form={form}>
          <FormItem label="用户名称" field="gameName" rules={[{ required: true, message: '请输入用户名称' }]}>
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem 
            label="openid" 
            field="openId" 
            rules={!formRef.current.id ? [{ required: true, message: '请输入openid' }] : []}
          >
            <Input placeholder="请输入..." readOnly={!!formRef.current.id} disabled={!!formRef.current.id} />
          </FormItem>
          <FormItem label="oneId" field="oneId">
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem 
            label="手机号" 
            field="phone" 
            rules={[
              { required: true, message: '请输入手机号' },
              {
                validator: (value, callback) => {
                  if (value && !/^1[3-9]\d{9}$/.test(value)) {
                    callback('请输入正确的中国手机号格式（11位数字，以1开头）');
                  } else {
                    callback();
                  }
                }
              }
            ]}
          >
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem label="是否拉黑" field="black" triggerPropName="checked">
            <Switch />
          </FormItem>
          <FormItem shouldUpdate={(prev, next) => prev.black !== next.black} noStyle>
            {values =>
              values.black ? (
                <FormItem
                  label="拉黑原因"
                  field="blackReason"
                  rules={[{ required: true, message: '请输入拉黑原因' }]}
                >
                  <Input.TextArea
                    placeholder="请输入拉黑原因"
                    maxLength={500}
                    showWordLimit
                    autoSize={{ minRows: 3, maxRows: 6 }}
                  />
                </FormItem>
              ) : null
            }
          </FormItem>
          <FormItem label="是否高手" field="isMaster" triggerPropName="checked">
            <Switch />
          </FormItem>
          <FormItem label="是否为会员" field="isMember" triggerPropName="checked">
            <Switch />
          </FormItem>
          <FormItem label="用户标签" field="tag">
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem label="用户头像" field="profilePic">
            <Upload
              action={URL_UPLOAD}
              headers={{
                'Authorization': `${localStorage.getItem('authToken')}`
              }}
              defaultFileList={form.getFieldValue('profilePic') ? [{ url: form.getFieldValue('profilePic'), uid: '-1', name: 'profilePic' }] : []}
              onChange={(_, file) => {
                if (file?.response?.data) {
                  form.setFieldValue('profilePic', file.response.data);
                }
              }}
              onRemove={() => {
                form.setFieldValue('profilePic', '');
              }}
              limit={1}
              imagePreview
              listType="picture-card"
              multiple={false}
              accept="image/*"
            />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default UserManagement;

